var _rect, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.667,
    y: 0.667,
    width: 14.667,
    height: 14.667,
    rx: 1,
    fill: "#A8FFF8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.333,
    r: 3,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 13.333h14v2H21v3.333H10.333v-5.333z",
    fill: "#14454C",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.667 3.594a.26.26 0 01.26-.261h11.479a.26.26 0 01.26.26v8.61a.26.26 0 01-.076.184l-2.87 2.87a.26.26 0 01-.184.076h-8.609a.26.26 0 01-.26-.26V3.592zm.521.26v10.957h8.24l2.717-2.716v-8.24H14.188z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.536 10.637V8.811h.261c.765 0 1.212-.13 1.467-.334.24-.192.36-.49.36-.97 0-.45-.167-.77-.402-.979a1.361 1.361 0 00-.903-.325c-.336 0-.663.112-.903.325-.235.21-.401.528-.401.979a.26.26 0 01-.522 0c0-.593.225-1.056.577-1.37a1.882 1.882 0 011.249-.456c.447 0 .902.148 1.25.457.351.313.576.776.576 1.369 0 .563-.142 1.048-.555 1.378-.352.282-.862.416-1.532.442v1.31a.26.26 0 01-.522 0zM17.058 12.724a.26.26 0 11-.522 0v-.521a.26.26 0 11.522 0v.521zM23.84 5.942a.26.26 0 110 .521h-2.608a.26.26 0 010-.521h2.608zM23.84 8.029a.26.26 0 110 .521h-2.608a.26.26 0 010-.521h2.608zM23.84 10.116a.26.26 0 110 .521h-4.173a.26.26 0 010-.521h4.173z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.797 12.463v1.98l1.979-1.98h-1.979zm-.522-.26a.26.26 0 01.261-.261h2.87a.261.261 0 01.184.445l-2.87 2.87a.26.26 0 01-.445-.185v-2.87z",
    fill: "#14454C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-quiz-21bd810c3b87f7edf9b52db0cd836789.svg";
export { SvgAiQuiz as ReactComponent };